import React, { useState, useEffect } from "react";
import Navigationbar from "../layouts/navigationbar";
import ProductApi from "../services/product";

function ProductPage() {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFail, setShowFail] = useState(false);
  const [product, setProduct] = useState([]);
  const [month, setMonth] = useState([3, 6, 9, 12]);
  const [selectedPrice, setSelectedPrice] = useState(15000);
  const [selectedMonth, setSelectedMonth] = useState(3);
  const [selectedPid, setSelectedPid] = useState("1");
  const [proResult, setProResult] = useState();

  useEffect(() => {
    ProductApi.getList()
      .then((res) => {
        setProduct(res.lists);
      })
      .catch();
  }, []);
  function chargeProduct(event) {
    event.preventDefault();
    return ProductApi.chargeProduct(
      event.target.card_no.value,
      selectedPid,
      selectedMonth,
      parseInt(selectedMonth) * parseInt(selectedPrice)
    )
      .then((res) => {
        if (res.issuccess === true) {
          setProResult(res.resultMessage);
          setShowSuccess(true);
          setTimeout(() => setShowSuccess(false), 3000);
        } else {
          setProResult(res.resultMessage);
          setShowFail(true);
          setTimeout(() => setShowFail(false), 3000);
        }
      })
      .catch((err) => alert({ err }));
  }
  /*
  function changePrice() {
    return (  );
  }
  
  export default changePrice;*/
  return (
    <div>
      <Navigationbar openStatus={false} />
      <div className="w-full p-8 ">
        {showSuccess && (
          <div className="mt-8">
            <div
              className="bg-green-400 text-white rounded border-t border-b border-green-500 px-4 py-3"
              role="alert"
            >
              <p className="font-bold text-xl ">{proResult}</p>
            </div>
          </div>
        )}
        {showFail && (
          <div className="mt-8">
            <div
              className="bg-red-400 text-white rounded border-t border-b border-red-500 px-4 py-3"
              role="alert"
            >
              <p className="font-bold text-xl ">{proResult}</p>
            </div>
          </div>
        )}
        <form
          className="d-flex flex-column"
          style={{ gap: "10px" }}
          onSubmit={chargeProduct}
        >
          <div className="mt-8">
            <label className="block text-gray-950 text-2xl font-bold mb-4">
              Картын дугаар
            </label>
            <input
              className="text-gray-700 text-xl border border-gray-300 rounded py-2 px-4 block w-full focus:outline-2 focus:outline-blue-700"
              type="number"
              name="card_no"
              inputMode="numeric"
              required
            />
          </div>
          <div className="mt-8">
            <label className="block text-gray-950 text-lg font-bold mb-4">
              Багц:
            </label>
            <select
              id="product_id"
              className="bg-blue-100 text-black py-2 px-4 w-full rounded hover:bg-blue-100 text-xl"
              onChange={(e) => {
                setSelectedPrice(
                  product.find((item) => item.productId == e.target.value).price
                );
                setSelectedPid(e.target.value);
              }}
            >
              {product.map((e) => (
                <option value={e.productId} key={e.productId}>
                  {e.name}
                </option>
              ))}
            </select>
          </div>
          <div className="mt-8">
            <label className="block text-gray-950 text-lg font-bold mb-4">
              Хугацаа (сар):
            </label>
            <select
              id="month"
              className="bg-blue-100 text-black py-2 px-4 w-full rounded hover:bg-blue-100 text-xl"
              onChange={(e) => {
                setSelectedMonth(e.target.value);
              }}
            >
              {month.map((e) => (
                <option value={e} key={e}>
                  {e} сар
                </option>
              ))}
            </select>
          </div>
          <div className="mt-8">
            <label className="block text-gray-950 text-lg font-bold mb-4">
              Үнэ
            </label>
            <label className="block text-xl mb-4 bg-blue-100 text-black py-2 px-4 w-full rounded">
              {parseInt(selectedMonth) * parseInt(selectedPrice)}
            </label>
          </div>
          <div className="mt-8">
            <button
              className="bg-blue-700 text-white font-bold py-2 px-4 w-full rounded hover:bg-blue-600 text-xl"
              type="submit"
            >
              Сунгах
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ProductPage;
